import {
    RECEIVE_NEWS_ITEM,
    REQUEST_NEWS_ITEM,
    SET_NEWS_ITEM_ERROR
  } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false
};

export default function newsItem(state = initialState, action) {
    switch (action.type) {
        case SET_NEWS_ITEM_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_NEWS_ITEM:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_NEWS_ITEM:
            return {
                ...state,
                isFetching: false,
                pageData: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/newsItem.js